// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\privacy.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\privacy.tsx");
  import.meta.hot.lastModified = "1790877538661.808";
}
// REMIX HMR END

import { Link } from "@remix-run/react";
import ThemeToggle from "~/components/ThemeToggle";
export const meta = () => {
  return [{
    title: "Privacy Policy - RamadPay Compliance"
  }, {
    name: "description",
    content: "Privacy policy for the RamadPay Compliance mobile application"
  }];
};
export default function Privacy() {
  return <div className="min-h-screen" style={{
    backgroundColor: "var(--color-bg-page)"
  }}>
      {/* Header */}
      <header style={{
      backgroundColor: "var(--color-brand)"
    }} className="shadow">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="bg-white rounded-lg p-1 shadow">
              <img src="/logo.png" alt="RamadPay" className="h-8 w-auto" onError={e => {
              e.target.style.display = "none";
            }} />
            </div>
            <span className="text-white font-bold text-lg">RamadPay Compliance</span>
          </Link>
          <ThemeToggle />
        </div>
      </header>

      {/* Content */}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="rounded-xl shadow-md p-8 sm:p-12" style={{
        backgroundColor: "var(--color-bg-surface)"
      }}>

          <h1 className="text-3xl font-bold mb-2" style={{
          color: "var(--color-text-primary)"
        }}>
            Privacy Policy
          </h1>
          <p className="text-sm mb-8" style={{
          color: "var(--color-text-muted)"
        }}>
            Effective Date: April 17, 2026 &nbsp;·&nbsp; Ramad Pay Inc.
          </p>

          <p className="mb-8 leading-relaxed" style={{
          color: "var(--color-text-secondary)"
        }}>
            Ramad Pay Inc. ("we", "us", or "our") operates the RamadPay Compliance mobile application (the "App").
            This Privacy Policy explains how we collect, use, store, and protect information when you use our App.
            By using the App, you agree to the practices described in this policy.
          </p>

          {[{
          title: "1. Information We Collect",
          content: <ul className="list-disc list-inside space-y-2" style={{
            color: "var(--color-text-secondary)"
          }}>
                  <li><strong>Account Information:</strong> Name, email address, and password used to access the App</li>
                  <li><strong>Transaction Data:</strong> Payment amounts, recipient details, and transaction records</li>
                  <li><strong>Compliance Documents:</strong> Identity documents, photos, PDFs, and other files uploaded for compliance review</li>
                  <li><strong>Biometric Data:</strong> Face ID / Touch ID authentication (processed locally on your device only — we never store biometric data)</li>
                  <li><strong>Device Information:</strong> Device type, operating system version, and app version for support purposes</li>
                </ul>
        }, {
          title: "2. How We Use Your Information",
          content: <ul className="list-disc list-inside space-y-2" style={{
            color: "var(--color-text-secondary)"
          }}>
                  <li>To process and review compliance transactions submitted through the App</li>
                  <li>To verify agent identity and maintain account security</li>
                  <li>To meet Anti-Money Laundering (AML) and Know Your Customer (KYC) regulatory requirements</li>
                  <li>To send push notifications regarding the status of your submitted transactions</li>
                  <li>To improve app performance and resolve technical issues</li>
                </ul>
        }, {
          title: "3. How We Store and Protect Your Information",
          content: <ul className="list-disc list-inside space-y-2" style={{
            color: "var(--color-text-secondary)"
          }}>
                  <li>All data is encrypted in transit using TLS with certificate pinning</li>
                  <li>Access to data is restricted to authorized compliance staff only</li>
                  <li>Documents and transaction records are retained in accordance with applicable regulatory requirements</li>
                  <li>Sessions automatically expire after a period of inactivity to protect your account</li>
                  <li>Passwords are subject to a 90-day expiry policy for security</li>
                </ul>
        }, {
          title: "4. Who We Share Your Information With",
          content: <ul className="list-disc list-inside space-y-2" style={{
            color: "var(--color-text-secondary)"
          }}>
                  <li><strong>Internal compliance reviewers</strong> at Ramad Pay Inc. who process submitted transactions</li>
                  <li><strong>Regulatory and law enforcement authorities</strong> when required by law</li>
                  <li>We do <strong>not</strong> sell, rent, or share your information with third parties for advertising or marketing purposes</li>
                </ul>
        }, {
          title: "5. Your Rights",
          content: <ul className="list-disc list-inside space-y-2" style={{
            color: "var(--color-text-secondary)"
          }}>
                  <li>Request access to the personal data we hold about you</li>
                  <li>Request correction of inaccurate information</li>
                  <li>Request deletion of your data, subject to regulatory retention obligations</li>
                  <li>Withdraw consent where processing is based on consent</li>
                </ul>
        }, {
          title: "6. Children's Privacy",
          content: <p style={{
            color: "var(--color-text-secondary)"
          }}>
                  The App is intended for use by authorized remittance agents only. We do not knowingly collect
                  personal information from individuals under the age of 18.
                </p>
        }, {
          title: "7. Changes to This Policy",
          content: <p style={{
            color: "var(--color-text-secondary)"
          }}>
                  We may update this Privacy Policy from time to time. Any changes will be reflected with an updated
                  effective date at the top of this page. Continued use of the App after changes constitutes your
                  acceptance of the updated policy.
                </p>
        }, {
          title: "8. Contact Us",
          content: <p style={{
            color: "var(--color-text-secondary)"
          }}>
                  If you have any questions or concerns about this Privacy Policy or how your data is handled,
                  please contact us at:{" "}
                  <a href="mailto:info@ramadpay.com" style={{
              color: "var(--color-brand)"
            }} className="font-medium hover:underline">
                    info@ramadpay.com
                  </a>
                  <br />
                  <span className="mt-1 block">Ramad Pay Inc.</span>
                </p>
        }].map(section => <section key={section.title} className="mb-8">
              <h2 className="text-lg font-semibold mb-3" style={{
            color: "var(--color-brand)"
          }}>
                {section.title}
              </h2>
              <div className="leading-relaxed">{section.content}</div>
              <div className="mt-6 border-t" style={{
            borderColor: "var(--color-border)"
          }} />
            </section>)}

        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-sm" style={{
      color: "var(--color-text-muted)"
    }}>
        © {new Date().getFullYear()} Ramad Pay Inc. All rights reserved.
      </footer>
    </div>;
}
_c = Privacy;
var _c;
$RefreshReg$(_c, "Privacy");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;